var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm._v("\n  DEVELOPMENT "), _c('br'), _c('br'), _vm._v("\n  TextFormattingButtons\n  "), _c('br'), _c('br'), _c('TextFormattingButtons', {
    attrs: {
      "options": _vm.optionsTextFormattingButtons
    }
  }), _vm._v("\n  Clicked button: "), _c('b', [_vm._v(_vm._s(_vm.clickedButtonFromTextFormattingButtons))])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }